exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dropzone__1gx {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #e7e9ed;\n  height: 80px; }\n\n.dropzone__1gx:hover,\n.dropzoneActive__2vZ {\n  border-color: #caced7;\n  cursor: pointer; }\n", ""]);
// Exports
exports.locals = {
	"dropzone": "dropzone__1gx",
	"dropzoneActive": "dropzoneActive__2vZ"
};